import React from 'react';

import { StatusFile } from '@/utils/enum';

import { Content } from './Content';
import { Accordion } from '../Accordion';

import type { BeraClipFile, BeraReportV2 } from '@/types/Bera';
import type { StrainIndexReport } from '@/types/StrainIndex';

interface TlidAccordionProps {
	report: BeraReportV2;
	open: boolean;
	onToggle: (reportId: string) => void;
	clip?: BeraClipFile | null;
	thumbnailUrl?: string | null;
	strainIndex?: StrainIndexReport;
	onOpenClip?: (clip: BeraClipFile) => void;
}

export function TlidAccordion(props: Readonly<TlidAccordionProps>): JSX.Element {
	const { report, open, onToggle, clip, thumbnailUrl, strainIndex, onOpenClip } = props;

	const isClipReady = clip?.status === StatusFile.PROCESSED && !!clip.url;

	function handleToggle(): void {
		onToggle(report.id);
	}

	function handleOpenClip(): void {
		if (!clip) {
			return;
		}

		onOpenClip?.(clip);
	}

	const onTitleClick = isClipReady && onOpenClip ? handleOpenClip : undefined;

	return (
		<Accordion underline title={report.task_name} open={open} onToggle={handleToggle} onTitleClick={onTitleClick}>
			<Content report={report} clip={clip} thumbnailUrl={thumbnailUrl} strainIndex={strainIndex} />
		</Accordion>
	);
}
